import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';

import { Observable } from 'rxjs/Observable';

import { SelectEventService } from './select-event-type.service';
import { ProgrammingUtilsService as Utils } from './../../common/services/utils.service';
import { SharedProgrammingService, CommonProgrammingContext } from '../../common/services/shared-programming.service';
import { QSRoomsService, RoomsProgrammingContext, Room } from '../quickstart-rooms/quickstart-rooms.service';

@Component({
  selector: 'prg-select-event-type',
  templateUrl: './select-event-type.component.html',
  styleUrls: ['./select-event-type.component.less']
})
export class SelectEventTypeComponent implements OnInit {

  private _ready: Observable<boolean>;
  private _searchText: string;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    private store: Store<{
      sharedProgramming: CommonProgrammingContext,
      roomsProgramming: RoomsProgrammingContext
    }>,
    private _roomsService: QSRoomsService,
    private shared: SharedProgrammingService,
    private utils: Utils,
    private selectEventService: SelectEventService
  ) {
    this._ready = this.selectEventService.ready;
    this._searchText = '';
  }

  ngOnInit() {
    this.shared.clearSelectedEvent();
  }

  searchTextChanged(event: any) {
    this.shared.setSearchText(event.target.value);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/select-event-type/select-event-type.component.ts